module.exports = __webpack_public_path__ + "a2c34a8866575bbeadad9a22dbbb9227.svg";